document.addEventListener('DOMContentLoaded', function () {
    const quantityDecrementButton = document.querySelector('.decrement');
    const quantityIncrementButton = document.querySelector('.increment');
    const quantityResultSpan = document.querySelector('.calculator__quantity-result');
    const productDimensions = productSize.split('x').map((item) => item.trim());

    const space = parseFloat(productDimensions[0]) * parseFloat(productDimensions[1]);
    let quantity = 1;
    productQuantityUnit[productQuantityUnit.length - 2] = space / 10000;
    quantityResultSpan.textContent = productQuantityUnit.join(' ');
    function updateQuantity(value) {
        quantity += value;
        if (quantity < 1) {
            quantity = 1;
        }
        productQuantityUnit[productQuantityUnit.length - 2] = (quantity * space) / 10000;
        quantityResultSpan.textContent = productQuantityUnit.join(' ');
    }
    quantityDecrementButton.addEventListener('click', () => updateQuantity(-1));
    quantityIncrementButton.addEventListener('click', () => updateQuantity(1));
});